module.exports = __webpack_public_path__ + "img/frameImg.49d1d48c.png";